var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppShortcut24DpFill0Wght400Grad0Opsz241Mobrecharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 57.5C16.125 57.5 14.9479 57.0104 13.9688 56.0312C12.9896 55.0521 12.5 53.875 12.5 52.5V7.5C12.5 6.125 12.9896 4.94792 13.9688 3.96875C14.9479 2.98958 16.125 2.5 17.5 2.5H42.5C43.875 2.5 45.0521 2.98958 46.0312 3.96875C47.0104 4.94792 47.5 6.125 47.5 7.5V17.5H42.5V15H17.5V45H42.5V42.5H47.5V52.5C47.5 53.875 47.0104 55.0521 46.0312 56.0312C45.0521 57.0104 43.875 57.5 42.5 57.5H17.5ZM17.5 50V52.5H42.5V50H17.5ZM17.5 10H42.5V7.5H17.5V10ZM42.875 32.5H30V40H25V32.5C25 31.125 25.4896 29.9479 26.4688 28.9688C27.4479 27.9896 28.625 27.5 30 27.5H42.875L39 23.5L42.5 20L52.5 30L42.5 40L39 36.5L42.875 32.5Z",
    fill: "#031273"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppShortcut24DpFill0Wght400Grad0Opsz241Mobrecharge);
export default __webpack_public_path__ + "static/media/app_shortcut_24dp_FILL0_wght400_GRAD0_opsz24 1mobrecharge.bec30c39843c42b986f5a26ded29d0a4.svg";
export { ForwardRef as ReactComponent };